import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import rolesReducer from './rolesSlice';
import userResponseReducer from './userResponseSlice';
import submissionDialogReducer from './submissionDialogState';

export const store = configureStore({
    reducer: {
        user: userReducer,
        roles: rolesReducer,
        userDetail: userResponseReducer,
        submissionDialog: submissionDialogReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
